import { Code } from '@chakra-ui/react';
import { FunctionComponent as FC, useMemo } from 'react';
import { useEntityJsonViewer } from '../../services/entityJsonViewer';
import { fonts } from '../../styles/theme';
import { MBox } from '../Monetize';
import { MCopyTextButton } from '../Monetize/MCopyTextButton';
import { MDrawerContainer } from './MDrawerContainer';

const AppEntityJsonViewer: FC = () => {
  const { drawerData, closeDrawer } = useEntityJsonViewer();

  const prettyJson = useMemo(() => {
    if (!drawerData?.json) {
      return '';
    }
    try {
      return JSON.stringify(drawerData.json, null, 2);
    } catch (e) {
      return '';
    }
  }, [drawerData]);

  if (!drawerData) {
    return null;
  }

  return (
    <MDrawerContainer
      isOpen
      onClose={() => {
        drawerData.onClose?.();
        closeDrawer();
      }}
      header={drawerData.title}
      refToFocusOnClose={drawerData.finalFocusRef}
      drawerBtnProps={{ size: 'lg' }}
    >
      <MBox px="4">
        {!!prettyJson && (
          <pre>
            <Code w="100%" bgColor="tGray.sidebarDark" position="relative">
              <MBox position="absolute" top={2} right={2}>
                <MCopyTextButton
                  fontFamily={fonts.heading}
                  copyValue={prettyJson}
                />
              </MBox>
              {prettyJson}
            </Code>
          </pre>
        )}
      </MBox>
    </MDrawerContainer>
  );
};

export default AppEntityJsonViewer;
